import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["e_coupon", "submit"];

  initialize() {}

  onToggle() {
    this.submitTarget.disabled = false;
  }
}
